var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    "view-box": "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    width: 13.333,
    height: 2.5,
    rx: 1.25,
    transform: "translate(3.333 4.167)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    fillRule: "evenodd",
    opacity: 0.3,
    d: "M5.25,14.167H16.083a1.25,1.25,0,1,1,0,2.5H5.25a1.25,1.25,0,1,1,0-2.5ZM5.25,10H16.083a1.25,1.25,0,0,1,0,2.5H5.25a1.25,1.25,0,0,1,0-2.5Z",
    transform: "translate(-0.667 -1.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.211d4fb3b119698e00aeea78552d249a.svg";
export { ForwardRef as ReactComponent };